export default {
  /**
   * @description call MOVE_DATA method to edit targetId to correspond clicked button id.
   * @param {ClickEvent} event clicked item
   */
  collabdata: ({ commit }, event) => {
    commit("MOVE_DATA", event);
  },
  initialLoad: ({ commit }, value) => {
    commit("INITIAL_LOAD", value);
  },
  tukaReady: ({ commit }, value) => {
    commit("TUKA_READY", value);
  },
  updateCurrentItemLocationData: ({ commit }, payload) => {
    commit("UPDATE_CURRENT_ITEM_LOCATION_DATA", payload);
  },
  setSettings: ({ commit }, data) => {
    commit("SET_SETTINGS", data);
  },
  setMainContent: ({ commit }, data) => {
    commit("SET_MAIN_CONTENT", data);
  },
  setSidebarContent: ({ commit }, data) => {
    commit("SET_SIDEBAR_CONTENT", data);
  },
  setSearchResults: ({ commit }, payload) => {
    commit("SET_SEARCH_RESULTS", payload);
  },
  setVisibleContentId: ({ commit }, id) => {
    commit("SET_VISIBLE_CONTENT_ID", id);
  },
  // return current page to initial stage
  initComponent: ({ commit }) => {
    commit("INIT_COMPONENT_DATA");
  },
  initPortletId: ({ commit }, portletId) => {
    commit("INIT_PORTLET_ID", portletId);
  },
  initContainerId: ({ commit }, containerId) => {
    commit("INIT_CONTAINER_ID", containerId);
  },
  initThemeWords: ({ commit }, themeWords) => {
    commit("INIT_THEME_WORDS", themeWords);
  },
  initRootItem: ({ commit }, rootItem) => {
    commit("INIT_ROOT_ITEM", rootItem);
  },
  setTime: ({ commit }, time) => {
    commit("SET_TIME", time);
  },
  changeSidebarThemeWordsState: ({ commit }, themeWords) => {
    commit("CHANGE_SIDEBAR_THEME_WORDS_STATE", themeWords);
  },
  changeMainContentThemeWordsState: ({ commit }, themeWords) => {
    commit("CHANGE_MAIN_CONTENT_THEME_WORDS_STATE", themeWords);
  },
  setThemeWords: ({ commit }, themeWords) => {
    commit("SET_THEME_WORDS", themeWords);
  },
  setMainContentHasItemsWithActiveThemeWords: ({ commit }, value) => {
    commit("SET_MAIN_CONTENT_HAS_ITEMS_WITH_ACTIVE_THEME_WORDS", value);
  },
  setHash: ({ commit }, hash) => {
    commit("SET_HASH", hash);
  },
  setScrollingReserved: ({ commit }, reserved) => {
    commit("SET_SCROLLING_RESERVED", reserved);
  },
  setTextSearchValue: ({ commit }, value) => {
    commit("SET_TEXT_SEARCH_VALUE", value);
  },
  setTextSearchStaticValue: ({ commit }, value) => {
    commit("SET_TEXT_SEARCH_STATIC_VALUE", value);
  },
  setWarnings: ({ commit }, warnings) => {
    commit("SET_WARNINGS", warnings);
  },
  setHeadersWithoutNumber: ({ commit }, payload) => {
    commit("SET_HEADERS_WITHOUT_ORDER_NUM", payload)
  }
};
